/**
 * D331: the world as the map draws it. While the Decorations sheet is open, a decoration being
 * tried on is shown on the player's own world before it is bought. Looks only: never stored.
 * D454 step 3: while arranging, the draft layout is in place of the world's own.
 */
import { useMemo } from 'preact/hooks';
import { idlePreviewDecorations, type IdleWorldState } from '@hedgerow/sim';
import { idleContent, useIdle } from './store.ts';

export function useShownWorld(): IdleWorldState | null {
  const world = useIdle((s) => s.world);
  const open = useIdle((s) => s.decorOpen);
  const trying = useIdle((s) => s.decorPreview);
  const arrange = useIdle((s) => s.arrange);
  const layout = arrange?.layout;
  return useMemo(() => {
    const base = world && open ? idlePreviewDecorations(world, idleContent, trying) : world;
    return base && layout ? { ...base, layout } : base;
  }, [world, open, trying, layout]);
}
